<template>
  <el-card class="my-achieve">
    <el-row>
      <el-col :span="12">
        <h3>{{ userName }}个人能力概况</h3>
        <div class="radar-chart" id="radar-chart"></div>
      </el-col>
      <el-col :span="12">
        <h3>AI学习建议</h3>
        <el-card shadow="never" :body-style="{ padding: '15px', height: '340px', 'overflow-y': 'auto' }">
          <vue-markdown id="content" class="suggestion" :source="markdownText"></vue-markdown>
        </el-card>
      </el-col>
    </el-row>
    <el-table :data="tableData" border class="table-1" :span-method="objectSpanMethod">
      <el-table-column prop="indicator_name" label="指标"></el-table-column>
      <el-table-column prop="tier" label="等级">
        <template slot-scope="scope">
          {{ scope.row.tier }}
          <div v-if="scope.row.tier !== '-'">评语：{{ scope.row.evaluation }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="sectionName" label="权重-主题"></el-table-column>
      <el-table-column prop="activityName" label="权重-活动"></el-table-column>
      <el-table-column prop="grade" label="成绩"></el-table-column>
    </el-table>
  </el-card>
</template>
<script>
import VueMarkdown from 'vue-markdown'
import { timestampToTime } from '@/utils/format.js'
export default {
  name: 'myAbility',
  components: {
    VueMarkdown,
  },
  data() {
    return {
      suggestion: `暂无建议`,
      suggestionTime: '',
      tableData: [],
      radarData: [],
      mergeObj: {}, // 用来记录需要合并行的下标
      mergeArr: ['indicator_name', 'tier', 'sectionName', 'activityName'], // 表格中的列名
      indicatorGrade: {
        '-': 0,
        A: 100,
        B: 75,
        C: 50,
        D: 25,
      },
      userName: '',
      interval: null,
    }
  },
  computed: {
    markdownText() {
      let finishText = this.timestampToTime
        ? `<p style="text-align:right;">AI助理</p><p style="text-align:right;">${this.timestampToTime}</p>`
        : ''
      return this.suggestion ? `${this.suggestion}${finishText}` : '暂无建议'
    },
  },
  mounted() {
    this.getCourseCapabilityStatStudent()
    this.getCapabilityAiSuggestion()
  },
  beforeDestroy() {
    this.clearInterval()
  },
  methods: {
    /**
     * 合并单元格
     * @returm {rowspan: 1,colspan: 1} 表示表格不变
     * @return (rowspan: 2,colspan: 1} 表示表格向下合并一个单元格
     * @return {rowspan: 1,colspan: 2} 表示表格向右合并一个单元格
     * @returm (rowspan: 0,colspan: 0} 表示删除此单元格
     */
    // eslint-disable-next-line no-unused-vars
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 判断列的属性
      if (this.mergeArr.indexOf(column.property) !== -1) {
        // 判断其值是不是为0
        if (this.mergeObj[column.property][rowIndex]) {
          return [this.mergeObj[column.property][rowIndex], 1]
        } else {
          // 如果为0则为需要合并的行
          return [0, 0]
        }
      }
    },
    // 获取数据
    getCourseCapabilityStatStudent() {
      let params = {
        course_id: this.$route.query.courseId,
      }
      let fnName = 'capability/getCourseCapabilityStatStudent'
      // 如果教师页查看能力达成
      if (this.$route.query.userId) {
        params.user_id = this.$route.query.userId
        this.userName = this.$route.query.userName
        fnName = 'capability/getCapabilityCourseStatStudent'
      }
      this.$store
        .dispatch(fnName, params)
        .then((res) => {
          if (res.code === 1) {
            let templist = []
            let radarData = []
            console.log('res', res.data)
            res.data.map((item) => {
              radarData.push({ name: item.indicator_name, tier: item.tier, tier_avg: item.tier_avg })
              item.data.map((_item) => {
                _item.activity.map((activity) => {
                  templist.push({
                    indicator_name: item.indicator_name,
                    tier: item.tier,
                    section_id: item.data.section_id,
                    sectionName: _item.weight + '%-' + _item?.name,
                    activityName: activity.weight + '%-' + activity.name,
                    name: activity.name,
                    grade: activity.grade || '-',
                    evaluation: item.evaluation || '-',
                  })
                })
              })
            }) || []
            
            this.tableData = templist
            this.radarData = radarData
            this.getSpanArr(this.tableData)
            if (this.radarData.length) this.iniRadarChart()
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    // 参考：https://blog.csdn.net/qq_43432158/article/details/126402868/
    getSpanArr(data) {
      this.mergeArr.forEach((key) => {
        let count = 0 // 用来记录需要合并行的起始位置
        this.mergeObj[key] = [] // 记录每一列的合并信息
        data.forEach((item, index) => {
          // index == 0表示数据为第一行，直接 push 一个 1
          if (index === 0) {
            this.mergeObj[key].push(1)
          } else {
            // 判断上下行值是否相等 如果相等，count+1 表示当前行需要合并，并push一个0作为占位
            // 因为不同指标名下主题和等级会有相同的情况，所以indicator_name用来限制同一个指标名下才可以合并
            if (item[key] === data[index - 1][key] && item.indicator_name === data[index - 1].indicator_name) {
              this.mergeObj[key][count] += 1
              this.mergeObj[key].push(0)
            } else {
              // 如果当前行和上一行其值不相等
              count = index // 记录当前位置
              this.mergeObj[key].push(1) // 重新push 一个 1
            }
          }
        })
      })
    },
    // 雷达图
    iniRadarChart() {
      console.log('radarData', this.radarData)
      var chart = this.$echarts.init(document.getElementById('radar-chart'))
      var option = {
        color: ['#FA9A34', '#409EFF'],
        legend: {
          show: true,
          data: ['个人能力评价', '平均能力评价'],
        },
        radar: {
          splitNumber: 4,
          radius: '70%',
          indicator: this.radarData.map((item) => {
            return {
              name: item.name,
              max: 100,
            }
          }),
        },
        series: [
          {
            name: '',
            type: 'radar',
            data: [
              {
                value: this.radarData.map((item) => this.indicatorGrade[item.tier]),
                name: '个人能力评价',
                areaStyle: {
                  color: new this.$echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                    {
                      color: 'rgba(249, 153, 63, 0.1)',
                      offset: 0,
                    },
                    {
                      color: 'rgba(249, 153, 63, 0.9)',
                      offset: 1,
                    },
                  ]),
                },
              },
              {
                value: this.radarData.map((item) => this.indicatorGrade[item.tier_avg]),
                name: '平均能力评价',
                areaStyle: {
                  color: new this.$echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                    {
                      color: 'rgba(64, 158, 255, 0.5)',
                      offset: 0,
                    },
                    {
                      color: 'rgba(64, 158, 255, 0.1)',
                      offset: 1,
                    },
                  ]),
                },
              },
            ],
          },
        ],
      }
      chart.setOption(option)
      this.platFormChart = chart
    },
    clearInterval() {
      if (this.interval) clearInterval(this.interval)
    },
    getCapabilityAiSuggestion() {
      let params = {
        course_id: this.$route.query.courseId,
      }
      if (this.$route.query.userId) {
        params.user_id = this.$route.query.userId
      }
      this.$store
        .dispatch('capability/getCapabilityAiSuggestion', params)
        .then((res) => {
          if (res.code === 1) {
            let status = res.data.status
            this.timestampToTime = ''
            if (status < 3) {
              this.suggestion = status === 2 ? 'AI建议正生成，请稍后' : 'AI建议正等待生成，请稍后查看'
              this.interval = setInterval(() => {
                this.getCapabilityAiSuggestion()
              }, 60 * 1000)
            } else if (status === 3) {
              this.suggestion = '请求失败，请联系管理员'
            } else if (status === 4) {
              this.suggestion = res.data.content
              this.timestampToTime = timestampToTime(res.data.send_time * 1000, 'YY-MM-DD HH:mm:ss')
            }
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.my-achieve {
  .radar-chart {
    height: 400px;
  }
  .suggestion {
    color: #6c757d;
  }
  ::v-deep .el-table {
    thead {
      th.el-table__cell {
        background-color: #f5f7fa;
      }
    }
    .cell {
      color: #6c757d;
    }
  }
}
</style>
